<template>
  <div>
    <div v-for="(item,index) in form.repairPlanData" :key="index">
      <el-form-item class="width100">
        <el-link type="danger" style="float:right" @click="handleDeleteItem(index)">移除</el-link>
      </el-form-item>
      <el-form-item label="修复方案名称：" :prop="`repairPlanData[${index}].name`" :rules="{required: true,message: '请输入',trigger: 'change'}">
        <el-input v-model="item.name" placeholder="请输入方案名称" />
      </el-form-item>
      <el-form-item label="封面图：" :prop="`repairPlanData[${index}].coverImage`" :rules="{required: true,message: '请输入',trigger: 'change'}">
        <div class="flexs">
          <imageUpload v-model="item.coverImage" width="32" height="32" />
          <span class="hint hint1">限制上传1张<br />建议尺寸196x248像素以上</span>
        </div>
      </el-form-item>
      <el-form-item label="方案介绍：" class="width100">
        <el-input v-model="item.introduce" placeholder="请输入方案介绍" maxlength="200" show-word-limit />
      </el-form-item>
      <el-form-item label="详情：" class="width100">
        <editor v-model="item.contentDetails " :min-height="240" :height="240" :uploadUrl="uploadUrl" />
      </el-form-item>
    </div>
    <el-form-item>
      <el-button type="primary" @click="handleAddItem()" icon="el-icon-plus">添加修复方案</el-button>
    </el-form-item>
  </div>
</template>

<script>
import ImageUpload from "@/components/ImageUpload";
import FileUpload from "@/components/FileUpload"
import Editor from "@/components/Editor";
export default {
  props: ['form'],
  components: { ImageUpload, FileUpload, Editor },
  data() {
    return {
      sysGoods: []
    }
  },
  created() {
  },
  methods: {
    handleDeleteItem(index) {
      this.form.repairPlanData.splice(index, 1)

    },
    handleAddItem() {
      this.form.repairPlanData.push({ name: '', coverImage: '', introduce: '', contentDetails: '', state: 1 })
    }
  }

}
</script>

<style lang="scss" scoped>
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
</style>